import dayjs from "dayjs";

export const formatPaymentDate = (dateString: string, format = "M/D/YYYY") => {
  if (!dateString) return "";
  
  // Check if it's a date-only value (midnight UTC time)
  if (dateString.endsWith("T00:00:00Z") || dateString.endsWith("T00:00:00.000Z")) {
    return dayjs.utc(dateString).format(format);
  }
  
  // For actual datetime values, show in local timezone
  return dayjs(dateString).format(format);
};